import { faCheck, faCheckCircle } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, List, ListItemText, Typography, useTheme } from "@mui/material"
import Button from "components/Button"
import { Fragment } from "react"
import {
  StyledBox,
  StyledGreyBox,
  StyledListItem,
  StyledListItemIcon,
  StyledSpan
} from "./ImportVtrForm.styled"
import NonFormikSidebar from "components/sidedrawer/NonFormikSidebar";
import { useTranslation } from "react-i18next"
import { CircleIcon } from "components/icons/CircleIcon"

const ImportVtrForm = (props: any) => {
  const { listRows, setShowContinueModal } = props
  const { t } = useTranslation()
  const theme = useTheme()

  const handleSubmit = () => {
    setShowContinueModal(true)
  }

  // filter company names if there is a duplicate
  const uniqueName: string[] = []
  const filteredNames = listRows.filter((name: any) => {
    const isDuplicate = uniqueName.includes(name.bolag)

    if (!isDuplicate) {
      uniqueName.push(name.bolag)

      return true
    }

    return false
  })

  return (
    <NonFormikSidebar
      sidebarId="ImportVtrForm"
    >
      <List>
        <StyledListItem>
          <StyledBox>
            <StyledListItemIcon>
              {listRows ? (
                <CircleIcon icon={faCheck} size="lg" backgroundColor={(theme.palette as any).green[200]} color={(theme.palette as any).green[900]} />
              ) : (
                <CircleIcon icon={faCheck} size="lg" />
              )}
            </StyledListItemIcon>

            <ListItemText
              primary={
                <Typography color="textPrimary" variant="h2">
                  {t("global.import_vehicles", "Import vehicles")}
                </Typography>
              }
              secondary={
                <Typography color="textSecondary" variant="bodySmall">
                  {t("settings.form.vtr_title", "Transport Agency")}
                </Typography>
              }
            />
          </StyledBox>
        </StyledListItem>
        {listRows.length > 0 ? (
          <Fragment>
            <Box mt={6}>
              <Typography color="textPrimary" variant="h3">
                {t("vehicleregistry.you_can_import", "You can import")}
                <StyledSpan>{" "}{listRows.length} {" "} st</StyledSpan>
                {" "}{t("vehicleregistry.vehicles_from_the_transport_agency", "vehicles from the Swedish Transport Agency, which belong to the companies:")}
              </Typography>
              <Box mt={2}>
                {filteredNames.map((name: any) => (
                  <Typography fontWeight="500" mb={1} display="block" color="textPrimary" variant="h5">
                    - {name.bolag}
                  </Typography>
                ))}
              </Box>

              <Box mt={4}>
                <Typography color="textSecondary" variant="bodyMedium">
                  {t("vehicleregistry.to_complete_the_vehicle_import", `To complete the vehicle import, click “import vehicle”`)}
                </Typography>
              </Box>
            </Box>
            <StyledGreyBox mt={8} pt={2}>
              <Button onClick={handleSubmit} color="primary" variant="contained">
                {t("global.import_vehicles", "Import vehicles")}
              </Button>
            </StyledGreyBox>
          </Fragment>
        ) : (
          <Box mt={6}>
            <Typography color="textPrimary" variant="h3">
              {t("vehicleregistry.you_currently_have_no_vehicles_to_import", "You currently have no vehicles to import from the Swedish Transport Agency.")}
            </Typography>
          </Box>
        )}
      </List>
    </NonFormikSidebar>
  )
}

export default ImportVtrForm
